import { render, staticRenderFns } from "./TeaserVideo.vue?vue&type=template&id=5f5712e5&scoped=true"
import script from "./TeaserVideo.vue?vue&type=script&lang=js"
export * from "./TeaserVideo.vue?vue&type=script&lang=js"
import style0 from "./TeaserVideo.vue?vue&type=style&index=0&id=5f5712e5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5712e5",
  null
  
)

export default component.exports